module.exports = __webpack_public_path__ + "img/VUT.ad3e7b2e.svg";